export enum MeteringPointTabType {
    Details = 'Details',
    Metering = 'Metering',
    Logical = 'Logical',
    FunctionalControl = 'FunctionalControl'
  }